/**
 * Category nav interactivity: the "All Categories" button opens a mega-menu
 * panel of every category link; the header's location button opens a small
 * city-picker dropdown, remembered in localStorage across visits.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var allBtn = document.querySelector('[data-all-categories-toggle]');
    var panel = document.querySelector('[data-all-categories-panel]');
    if (allBtn && panel) {
      allBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        allBtn.setAttribute('aria-expanded', String(!isOpen));
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !panel.contains(e.target) && e.target !== allBtn) {
          panel.hidden = true;
          allBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          panel.hidden = true;
          allBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // --- Mobile drawer (hamburger) ---
    var drawer = document.querySelector('[data-mobile-drawer]');
    var burger = document.querySelector('[data-mobile-menu-toggle]');
    if (drawer && burger) {
      var openDrawer = function () {
        drawer.hidden = false;
        // Next frame so the transition runs from the off-screen start state.
        window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        burger.setAttribute('aria-expanded', 'true');
        burger.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      };
      var closeDrawer = function () {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.classList.remove('is-open');
        document.body.style.overflow = '';
        window.setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 260);
      };
      burger.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
      });
      drawer.querySelectorAll('[data-mobile-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });
    }

    var locationBtn = document.querySelector('[data-location-toggle]');
    var locationPanel = document.querySelector('[data-location-panel]');
    if (locationBtn && locationPanel) {
      var STORAGE_KEY = 'carzelo:location';
      var label = locationBtn.querySelector('[data-location-label]');
      try {
        var saved = window.localStorage.getItem(STORAGE_KEY);
        if (saved && label) label.textContent = saved;
      } catch (e) {}

      locationBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !locationPanel.hidden;
        locationPanel.hidden = isOpen;
        locationBtn.setAttribute('aria-expanded', String(!isOpen));
      });
      locationPanel.addEventListener('click', function (e) {
        var item = e.target.closest('[data-location-option]');
        if (!item) return;
        var value = item.textContent.trim();
        if (label) label.textContent = value;
        try { window.localStorage.setItem(STORAGE_KEY, value); } catch (err) {}
        locationPanel.hidden = true;
        locationBtn.setAttribute('aria-expanded', 'false');
      });
      document.addEventListener('click', function (e) {
        if (!locationPanel.hidden && !locationPanel.contains(e.target) && e.target !== locationBtn) {
          locationPanel.hidden = true;
          locationBtn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !locationPanel.hidden) {
          locationPanel.hidden = true;
          locationBtn.setAttribute('aria-expanded', 'false');
          locationBtn.focus();
        }
      });
    }
  });
})();
